import { Location } from "history";
import { matchPath } from "react-router-dom";
import { MODAL_ROUTES, ROUTES } from "routing/routes";

import {
  linkToDashboard,
  linkToDashboardFeedback,
  linkToDashboardInviteParentsModal,
  linkToSetDailyXPGoal,
  linkToUpdateDailyXPGoal
} from "features/dashboard/links";
import { linkToMorePage } from "features/dashboard/pages/more-page/links";
import { linkToSettings } from "features/dashboard/pages/settings-page/links";

export function locationIncludesMoreRoute(location: Location) {
  return (
    location.pathname.includes(linkToMorePage()) ||
    location.pathname.includes(linkToSettings()) ||
    location.pathname.includes(linkToDashboardFeedback()) ||
    location.pathname.includes(linkToDashboardInviteParentsModal()) ||
    location.pathname.includes(MODAL_ROUTES.CHOOSE_REGION.path)
  );
}

export function locationIncludesAssignmentsRoute({
  location
}: {
  location: Location;
}) {
  return location.pathname.includes(ROUTES.DASHBOARD.ASSIGNMENTS.path);
}

export function locationIncludesDashboardRoute({
  location
}: {
  location: Location;
}) {
  return (
    !!matchPath(location.pathname, {
      path: linkToDashboard(),
      exact: true
    }) ||
    location.pathname.includes(linkToSetDailyXPGoal()) ||
    location.pathname.includes(linkToUpdateDailyXPGoal())
  );
}
